<template>
    <div>
        <!-- Modal Aprovação de Desconto -->
        <div class="modal fade" id="modalAprovarDesconto" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="orcamento">
                    <div class="modal-header">
                        <h5 class="modal-title">Desconto</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info" v-if="orcamento.desconto_tipo">
                            {{ orcamento.desconto_tipo.search }}
                        </div>

                        <az-input
                            type="button-group"
                            :optionsList="[
                                { 
                                    id: 'A', search: 'Aprovar' 
                                }, 
                                { 
                                    id: 'S', search: 'Solicitar Aprovação' 
                                }, 
                            ]"
                            optionsData="id"
                            v-model="tipo_acao" />

                        <div class="mt-3" v-if="tipo_acao == 'S'">

                            <az-input
                                label="Solicitação aprovação por..."
                                type="autocomplete" 
                                optionsMode="aql"
                                optionsDisplay="search"
                                optionsName="usuarios-aprovacao"
                                service="usuarios.index"
                                :optionsParm="{ ativos: true }"
                                placeholder="Selecione o aprovador..."
                                :validate="validate"
                                required
                                v-model="para_usuario" />

                        </div>
                        
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            tipo_acao: "", 
            orcamento: null, 
            para_usuario: "", 
            validate: false, 
        };
    },

    components: { 
        AzInput, 
        AzSubmit, 
    }, 

    methods: { 
        abrir(orcamento) { 
            this.tipo_acao = '';
            this.validate = false; 
            this.orcamento = orcamento;

            $('#modalAprovarDesconto').modal('show');
        },

        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'orcamentos', 
                func: 'desconto_aprovacao', 
                dados: { 
                    id_orcamento: this.orcamento.id_orcamento,
                    id_desconto_tipo: this.orcamento.id_desconto_tipo, 
                    tipo_acao: this.tipo_acao,
                    id_usuario_aprovador: this.para_usuario ? this.para_usuario.id_usuario : null,
                }, 
                modal: 'modalAprovarDesconto',
                toast: true, 
                callback: res => { 
                    if ( this.tipo_acao == 'A' && res.orcamento && res.orcamento.usuario_desconto ) { 
                        this.orcamento.id_usuario_desconto = res.orcamento.id_usuario_desconto;
                        this.orcamento.usuario_desconto = res.orcamento.usuario_desconto;
                        this.orcamento.dt_desconto_autorizacao = res.orcamento.dt_desconto_autorizacao;
                        this.orcamento.fl_desconto_autorizado = res.orcamento.fl_desconto_autorizado;
                    }
                }
            });
        }
    }
}
</script>
